export default "__VITE_ASSET__824eb772__"